import * as Yup from "yup";

export default (t: any) => {
  return Yup.object().shape({
    userName: Yup.string()
      .typeError(t("UserNameisrequired"))
      .required(t("UserNameisrequired"))
      .min(4, t("UserNamemustbeatleast4chars"))
      .max(50, t("UserNamemustnotexceed50chars")),

    password: Yup.string()
      .typeError(t("Passwordisrequired"))
      .required(t("Passwordisrequired"))
      .min(8, t("Passwordmustbeatleast8chars"))
      .max(50, t("Passwordmustnotexceed50chars")),
  });
};
